import ArchiveIcon from '../../assets/icons/archive-icon.svg';
import ArchiveRestoreIcon from '../../assets/icons/archive-restore-icon.svg';
import ArchiveXIcon from '../../assets/icons/archive-x-icon.svg';
import AtSignIcon from '../../assets/icons/at-sign-icon.svg';
import AwardIcon from '../../assets/icons/award-icon.svg';
import BookmarkCheckIcon from '../../assets/icons/bookmark-check-icon.svg';
import BookmarkIcon from '../../assets/icons/bookmark-icon.svg';
import BuildingIcon from '../../assets/icons/building-icon.svg';
import CalendarClockIcon from '../../assets/icons/calendar-clock-icon.svg';
import CalendarFoldIcon from '../../assets/icons/calendar-fold-icon.svg';
import CameraOffIcon from '../../assets/icons/camera-off-icon.svg';
import ChevronDownIcon from '../../assets/icons/chevron-down-icon.svg';
import ChevronLeftIcon from '../../assets/icons/chevron-left-icon.svg';
import ChevronRightIcon from '../../assets/icons/chevron-right-icon.svg';
import CircleCheckIcon from '../../assets/icons/circle-check-icon.svg';
import CircleXIcon from '../../assets/icons/circle-x-icon.svg';
import CloudDownloadIcon from '../../assets/icons/cloud-download-icon.svg';
import CopyIcon from '../../assets/icons/copy-icon.svg';
import EllipsisVerticalIcon from '../../assets/icons/ellipsis-vertical-icon.svg';
import ExternalLinkIcon from '../../assets/icons/external-link-icon.svg';
import EyeIcon from '../../assets/icons/eye-icon.svg';
import EyeOffIcon from '../../assets/icons/eye-off-icon.svg';
import FileArchiveIcon from '../../assets/icons/file-archive-icon.svg';
import FileDownIcon from '../../assets/icons/file-down-icon.svg';
import FileHeartIcon from '../../assets/icons/file-heart-icon.svg';
import FileInputIcon from '../../assets/icons/file-input-icon.svg';
import FilePenLineIcon from '../../assets/icons/file-pen-line-icon.svg';
import FilePlusIcon from '../../assets/icons/file-plus-icon.svg';
import FileSlidersIcon from '../../assets/icons/file-sliders-icon.svg';
import FileSymlinkIcon from '../../assets/icons/file-symlink-icon.svg';
import FileUpIcon from '../../assets/icons/file-up-icon.svg';
import FileUserIcon from '../../assets/icons/file-user-icon.svg';
import FilesIcon from '../../assets/icons/files-icon.svg';
import FolderIcon from '../../assets/icons/folder-icon.svg';
import FolderInputIcon from '../../assets/icons/folder-input-icon.svg';
import FolderOutputIcon from '../../assets/icons/folder-output-icon.svg';
import FolderSymlinkIcon from '../../assets/icons/folder-symlink-icon.svg';
import FolderUpIcon from '../../assets/icons/folder-up-icon.svg';
import AdminIcon from '../../assets/icons/icon-admin.svg';
import CertifiedTimestampingIcon from '../../assets/icons/icon-certified-timestamping.svg';
import ContributorStorageLimitIcon from '../../assets/icons/icon-contributor-storage-limit.svg';
import ContributorIcon from '../../assets/icons/icon-contributor.svg';
import DeviceAccessLimitationIcon from '../../assets/icons/icon-device-access-limitation.svg';
import DownloadRestrictionsIcon from '../../assets/icons/icon-download-restrictions.svg';
import ShieldDownloadIcon from '../../assets/icons/icon-download-shield.svg';
import EditorFileManagementIcon from '../../assets/icons/icon-editor-file-management.svg';
import ExternalAccessLinkIcon from '../../assets/icons/icon-external-access-link.svg';
import ExternalFileSharingRestrictionIcon from '../../assets/icons/icon-external-file-sharing-restriction.svg';
import AiFileIcon from '../../assets/icons/icon-file-ai.svg';
import AudioFileIcon from '../../assets/icons/icon-file-audio.svg';
import FileAutoDeletionIcon from '../../assets/icons/icon-file-autodeletion.svg';
import CadFileIcon from '../../assets/icons/icon-file-cad.svg';
import CodeFileIcon from '../../assets/icons/icon-file-code.svg';
import DocumentsFileIcon from '../../assets/icons/icon-file-documents.svg';
import ExcelFileIcon from '../../assets/icons/icon-file-excel.svg';
import GifFileIcon from '../../assets/icons/icon-file-gif.svg';
import ImagesFileIcon from '../../assets/icons/icon-file-images.svg';
import PdfFileIcon from '../../assets/icons/icon-file-pdf.svg';
import PngFileIcon from '../../assets/icons/icon-file-png.svg';
import PptFileIcon from '../../assets/icons/icon-file-ppt.svg';
import PsdFileIcon from '../../assets/icons/icon-file-psd.svg';
import FileSalesPermissionIcon from '../../assets/icons/icon-file-sales-permission.svg';
import FileSizeLimitIcon from '../../assets/icons/icon-file-size-limit.svg';
import FileTypeRestrictionIcon from '../../assets/icons/icon-file-type-restriction.svg';
import UnknownFileIcon from '../../assets/icons/icon-file-unknown.svg';
import VideoFileIcon from '../../assets/icons/icon-file-video.svg';
import WordFileIcon from '../../assets/icons/icon-file-word.svg';
import FolderCreationPermissionIcon from '../../assets/icons/icon-folder-creation-permission.svg';
import IconFolder from '../../assets/icons/icon-folder.svg';
import GroupCreationControlIcon from '../../assets/icons/icon-group-creation-control.svg';
import ImageIcon from '../../assets/icons/icon-image.svg';
import ListIcon from '../../assets/icons/icon-list.svg';
import MenuIcon from '../../assets/icons/icon-menu.svg';
import MSOfficeControlIcon from '../../assets/icons/icon-msoffice-control.svg';
import NavArchiveIcon from '../../assets/icons/icon-nav-archive.svg';
import NewFolderIcon from '../../assets/icons/icon-new-folder.svg';
import PreviewEmptyIcon from '../../assets/icons/icon-preview-empty.svg';
import ProfilePictureIcon from '../../assets/icons/icon-profile-picture.svg';
import ReadOnlyIcon from '../../assets/icons/icon-read-only.svg';
import ReaderIcon from '../../assets/icons/icon-reader.svg';
import RemotegrantFileIcon from '../../assets/icons/icon-remotegrant-file.svg';
import SessionControlIcon from '../../assets/icons/icon-session-control.svg';
import ShareIcon from '../../assets/icons/icon-share.svg';
import SingleSignOnIcon from '../../assets/icons/icon-single-signon.svg';
import StarShadowIcon from '../../assets/icons/icon-star-shadow.svg';
import TagBasedSharingRestrictionIcon from '../../assets/icons/icon-tag-based-sharing-restriction.svg';
import TagEmptyIcon from '../../assets/icons/icon-tag-empty.svg';
import TagFullIcon from '../../assets/icons/icon-tag-full.svg';
import UploadWithTagIcon from '../../assets/icons/icon-upload-with-tag.svg';
import UserAtIcon from '../../assets/icons/icon-user-at.svg';
import UserDeniedIcon from '../../assets/icons/icon-user-denied.svg';
import UserRemoveIcon from '../../assets/icons/icon-user-remove.svg';
import UsersEditIcon from '../../assets/icons/icon-users-edit.svg';
import UsersRemoveIcon from '../../assets/icons/icon-users-remove.svg';
import VideoIcon from '../../assets/icons/icon-video.svg';
import ViewTrackingIcon from '../../assets/icons/icon-view-tracking.svg';
import WatermarkProtectionIcon from '../../assets/icons/icon-watermark-protection.svg';
import InfoIcon from '../../assets/icons/info-icon.svg';
import LayoutGridIcon from '../../assets/icons/layout-grid-icon.svg';
import LayoutListIcon from '../../assets/icons/layout-list-icon.svg';
import ListFilterIcon from '../../assets/icons/list-filter-icon.svg';
import LockIcon from '../../assets/icons/lock-icon.svg';
import MaximizeIcon from '../../assets/icons/maximize-icon.svg';
import MicrosoftEntraIDIcon from '../../assets/icons/microsoft-entra-id-icon.svg';
import PanelRightCloseIcon from '../../assets/icons/panel-right-close-icon.svg';
import PanelRightOpenIcon from '../../assets/icons/panel-right-open-icon.svg';
import PencilIcon from '../../assets/icons/pencil-icon.svg';
import PlugWithErrorIcon from '../../assets/icons/plug-with-error-icon.svg';
import ReplaceFileIcon from '../../assets/icons/replace-file-icon.svg';
import ReplaceIcon from '../../assets/icons/replace-icon.svg';
import SearchIcon from '../../assets/icons/search-icon.svg';
import ServerCrashIcon from '../../assets/icons/server-crash-icon.svg';
import SettingsIcon from '../../assets/icons/settings-icon.svg';
import ShieldCheckIcon from '../../assets/icons/shield-check-icon.svg';
import SquareArrowOutUpRight from '../../assets/icons/square-arrow-out-up-right.svg';
import SquareCheckBig from '../../assets/icons/square-check-big-icon.svg';
import SquarePenIcon from '../../assets/icons/square-pen-icon.svg';
import StarFullIcon from '../../assets/icons/star-full-icon.svg';
import StarIcon from '../../assets/icons/star-icon.svg';
import StarOffIcon from '../../assets/icons/star-off-icon.svg';
import StoreIcon from '../../assets/icons/store-icon.svg';
import SwatchBookIcon from '../../assets/icons/swatch-book-icon.svg';
import TagIcon from '../../assets/icons/tag-icon.svg';
import TrashIcon from '../../assets/icons/trash-icon.svg';
import TriangleAlertIcon from '../../assets/icons/triangle-alert-icon.svg';
import UnplugIcon from '../../assets/icons/unplug-icon.svg';
import UserCheckIcon from '../../assets/icons/user-check-icon.svg';
import UserCogIcon from '../../assets/icons/user-cog-icon.svg';
import UserIcon from '../../assets/icons/user-icon.svg';
import UserPenIcon from '../../assets/icons/user-pen-icon.svg';
import UserPlusIcon from '../../assets/icons/user-plus-icon.svg';
import UserXIcon from '../../assets/icons/user-x-icon.svg';
import UsersIcon from '../../assets/icons/users-icon.svg';
import ViewIcon from '../../assets/icons/view-icon.svg';
import Volume2Icon from '../../assets/icons/volume-2-icon.svg';
import VolumeOffIcon from '../../assets/icons/volume-off-icon.svg';
import XIcon from '../../assets/icons/x-icon.svg';
import FilegrantEnterpriseLogoExtended from '../../assets/images/filegrant-enterprise-logo-extended.svg';
import FilegrantLogoWhite from '../../assets/images/filegrant-logo-white.svg';
import FilegrantLogo from '../../assets/images/filegrant-logo.svg';
import NotFoundIllustration from '../../assets/images/illustration-not-found.svg';
import LoaderIcon from '../../assets/icons/loader-icon.svg';
import BrainCircuitIcon from '../../assets/icons/brain-circuit-icon.svg';
import KeySquareIcon from '../../assets/icons/key-square-icon.svg';
import GoogleLogoIcon from '../../assets/icons/google-logo-icon.svg';
import MicrosoftLogoIcon from '../../assets/icons/microsoft-logo-icon.svg';
import CybergrantLogoIcon from '../../assets/icons/cybergrant-logo-icon.svg';
import ScanTextIcon from '../../assets/icons/scan-text-icon.svg';
import BotMessageSquareIcon from '../../assets/icons/bot-message-square-icon.svg';
import TagsIcon from '../../assets/icons/tags-icon.svg';
import SendIcon from '../../assets/icons/send-icon.svg';
import FileXIcon from '../../assets/icons/file-x-icon.svg';
import LogsIcon from '../../assets/icons/logs-icon.svg';
import MessageSquarePlusIcon from '../../assets/icons/message-square-plus-icon.svg';
import SquareUserIcon from '../../assets/icons/square-user-icon.svg';
import ImageUpIcon from '../../assets/icons/image-up-icon.svg';
import ShieldUserIcon from '../../assets/icons/shield-user-icon.svg';
import FileSearchIcon from '../../assets/icons/file-search-icon.svg';
import TagAiLoaderIcon from '../../assets/icons/tag-ai-loader-icon.svg';
import TagAICheckIcon from '../../assets/icons/tag-ai-check-icon.svg';
import TagAiTriangleAlertIcon from '../../assets/icons/tag-ai-triangle-alert-icon.svg';
import TagAiIcon from '../../assets/icons/tag-ai-icon.svg';
import BadgeDollarSignIcon from '../../assets/icons/badge-dollar-sign-icon.svg';
import UsersPlusIcon from '../../assets/icons/users-plus-icon.svg';
import CircleAlertIcon from '../../assets/icons/circle-alert-icon.svg';
import CirclePlusIcon from '../../assets/icons/circle-plus-icon.svg';
import WaypointsIcon from '../../assets/icons/waypoints-icon.svg';
import UserStarIcon from '../../assets/icons/user-star-icon.svg';
import BlendIcon from '../../assets/icons/blend-icon.svg';

export const iconComponents = {
  UserPlusIcon,
  AdminIcon,
  AiFileIcon,
  ArchiveIcon,
  AudioFileIcon,
  CadFileIcon,
  CertifiedTimestampingIcon,
  CodeFileIcon,
  ContributorIcon,
  ContributorStorageLimitIcon,
  DeviceAccessLimitationIcon,
  DocumentsFileIcon,
  CloudDownloadIcon,
  DownloadRestrictionsIcon,
  EditorFileManagementIcon,
  ExcelFileIcon,
  ExternalAccessLinkIcon,
  ExternalFileSharingRestrictionIcon,
  EyeOffIcon,
  EyeIcon,
  FileAutoDeletionIcon,
  FileSalesPermissionIcon,
  FileSizeLimitIcon,
  FileTypeRestrictionIcon,
  FilegrantEnterpriseLogoExtended,
  FilegrantLogo,
  FilegrantLogoWhite,
  FolderCreationPermissionIcon,
  GifFileIcon,
  GroupCreationControlIcon,
  ImageIcon,
  ImagesFileIcon,
  ListIcon,
  MSOfficeControlIcon,
  MenuIcon,
  NavArchiveIcon,
  FileHeartIcon,
  IconFolder,
  UsersIcon,
  SettingsIcon,
  FileUserIcon,
  TrashIcon,
  UserIcon,
  NewFolderIcon,
  NotFoundIllustration,
  SquareArrowOutUpRight,
  PdfFileIcon,
  PngFileIcon,
  PptFileIcon,
  PreviewEmptyIcon,
  ProfilePictureIcon,
  PsdFileIcon,
  ChevronDownIcon,
  ReadOnlyIcon,
  ReaderIcon,
  RemotegrantFileIcon,
  SessionControlIcon,
  ShareIcon,
  ShieldDownloadIcon,
  SingleSignOnIcon,
  StarShadowIcon,
  TagBasedSharingRestrictionIcon,
  TagEmptyIcon,
  TagFullIcon,
  TagIcon,
  UnknownFileIcon,
  UploadWithTagIcon,
  UserAtIcon,
  UserDeniedIcon,
  SearchIcon,
  UserPenIcon,
  UserRemoveIcon,
  UsersEditIcon,
  UsersRemoveIcon,
  VideoFileIcon,
  VideoIcon,
  ViewTrackingIcon,
  WatermarkProtectionIcon,
  WordFileIcon,
  XIcon,
  FileArchiveIcon,
  CameraOffIcon,
  TriangleAlertIcon,
  ServerCrashIcon,
  PlugWithErrorIcon,
  CircleCheckIcon,
  BuildingIcon,
  ReplaceFileIcon,
  FileSymlinkIcon,
  ExternalLinkIcon,
  ChevronRightIcon,
  AtSignIcon,
  CalendarFoldIcon,
  FileSlidersIcon,
  AwardIcon,
  LockIcon,
  FolderIcon,
  FileInputIcon,
  UserXIcon,
  UserCheckIcon,
  UserCogIcon,
  FileDownIcon,
  FileUpIcon,
  FolderUpIcon,
  FilePenLineIcon,
  FolderInputIcon,
  FilesIcon,
  ReplaceIcon,
  ArchiveRestoreIcon,
  ArchiveXIcon,
  ShieldCheckIcon,
  FolderOutputIcon,
  StarOffIcon,
  StarIcon,
  FilePlusIcon,
  LayoutListIcon,
  LayoutGridIcon,
  SwatchBookIcon,
  PencilIcon,
  EllipsisVerticalIcon,
  BookmarkIcon,
  BookmarkCheckIcon,
  StarFullIcon,
  ChevronLeftIcon,
  PanelRightOpenIcon,
  PanelRightCloseIcon,
  CalendarClockIcon,
  CopyIcon,
  ListFilterIcon,
  UnplugIcon,
  CircleXIcon,
  MaximizeIcon,
  VolumeOffIcon,
  Volume2Icon,
  FolderSymlinkIcon,
  SquareCheckBig,
  StoreIcon,
  SquarePenIcon,
  ViewIcon,
  InfoIcon,
  MicrosoftEntraIDIcon,
  LoaderIcon,
  BrainCircuitIcon,
  KeySquareIcon,
  GoogleLogoIcon,
  MicrosoftLogoIcon,
  CybergrantLogoIcon,
  ScanTextIcon,
  BotMessageSquareIcon,
  TagsIcon,
  SendIcon,
  FileXIcon,
  LogsIcon,
  MessageSquarePlusIcon,
  SquareUserIcon,
  ImageUpIcon,
  ShieldUserIcon,
  FileSearchIcon,
  TagAiLoaderIcon,
  TagAICheckIcon,
  TagAiTriangleAlertIcon,
  TagAiIcon,
  BadgeDollarSignIcon,
  UsersPlusIcon,
  CircleAlertIcon,
  CirclePlusIcon,
  WaypointsIcon,
  UserStarIcon,
  BlendIcon,
};
